import { useEffect, useState } from 'react';

/** Logo marca animada conforme GUIA-EFEITO-LOGO-NOME-OMINIA (preset forte para landing). */
export function OminiaLogo({ size = 76 }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const s = `${size}px`;

  return (
    <div className="relative inline-flex items-center justify-center overflow-visible" style={{ width: s, height: s }}>
      <svg viewBox="0 0 100 100" width={size} height={size} className="overflow-visible" aria-hidden>
        <defs>
          <linearGradient id="ominia-ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(262, 83%, 58%)" />
            <stop offset="100%" stopColor="hsl(190, 90%, 50%)" />
          </linearGradient>
          <linearGradient id="ominia-ringGrad2" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="hsl(190, 90%, 50%)" />
            <stop offset="100%" stopColor="hsl(262, 83%, 58%)" />
          </linearGradient>
          <linearGradient id="ominia-coreFill" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(262, 83%, 58%)" stopOpacity="0.15" />
            <stop offset="100%" stopColor="hsl(190, 90%, 50%)" stopOpacity="0.08" />
          </linearGradient>
          <linearGradient id="ominia-coreStroke" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(262, 83%, 65%)" stopOpacity="0.6" />
            <stop offset="100%" stopColor="hsl(190, 90%, 55%)" stopOpacity="0.4" />
          </linearGradient>
        </defs>

        <g style={{ transformOrigin: '50px 50px', animation: 'ominia-spin-slow 14s linear infinite', opacity: mounted ? 1 : 0 }}>
          <circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            stroke="url(#ominia-ringGrad)"
            strokeWidth="1.5"
            strokeDasharray="8 6"
            opacity={0.66}
          />
        </g>

        <g style={{ transformOrigin: '50px 50px', opacity: mounted ? 1 : 0, transition: 'opacity 1.2s ease 0.2s' }}>
          <circle
            cx="50"
            cy="50"
            r="36"
            fill="none"
            stroke="url(#ominia-ringGrad2)"
            strokeWidth={1}
            className="ominia-ring-pulse"
          />
        </g>

        <polygon
          points="50,18 74,32 74,60 50,74 26,60 26,32"
          fill="url(#ominia-coreFill)"
          stroke="url(#ominia-coreStroke)"
          strokeWidth="1.5"
          opacity={mounted ? 1 : 0}
          style={{
            transition: 'opacity 0.8s ease 0.2s',
            filter: 'drop-shadow(0 0 12px hsl(262 83% 58% / 0.36))',
          }}
        />

        <g opacity={mounted ? 0.85 : 0} style={{ transition: 'opacity 1s ease 0.4s' }}>
          <circle cx="50" cy="46" r="3" fill="hsl(190, 90%, 60%)" className="ominia-node-pulse" />
          <circle cx="38" cy="36" r="2" fill="hsl(262, 83%, 70%)" className="ominia-node-pulse" style={{ animationDelay: '0.25s' }} />
          <circle cx="62" cy="36" r="2" fill="hsl(262, 83%, 70%)" className="ominia-node-pulse" style={{ animationDelay: '0.5s' }} />
          <circle cx="38" cy="56" r="2" fill="hsl(262, 83%, 70%)" className="ominia-node-pulse" style={{ animationDelay: '0.75s' }} />
          <circle cx="62" cy="56" r="2" fill="hsl(262, 83%, 70%)" className="ominia-node-pulse" style={{ animationDelay: '1s' }} />
          <circle cx="50" cy="62" r="2" fill="hsl(190, 90%, 60%)" className="ominia-node-pulse" style={{ animationDelay: '0.35s' }} />
          <line x1="50" y1="46" x2="38" y2="36" stroke="hsl(262, 83%, 65%)" strokeWidth="0.8" opacity="0.5" />
          <line x1="50" y1="46" x2="62" y2="36" stroke="hsl(262, 83%, 65%)" strokeWidth="0.8" opacity="0.5" />
          <line x1="50" y1="46" x2="38" y2="56" stroke="hsl(190, 90%, 55%)" strokeWidth="0.8" opacity="0.5" />
          <line x1="50" y1="46" x2="62" y2="56" stroke="hsl(190, 90%, 55%)" strokeWidth="0.8" opacity="0.5" />
          <line x1="50" y1="46" x2="50" y2="62" stroke="hsl(190, 90%, 55%)" strokeWidth="0.8" opacity="0.5" />
        </g>

      </svg>

      <style>{`
        @keyframes ominia-spin-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes ominia-ring-pulse {
          0%, 100% { opacity: 0.35; transform: scale(1); }
          50% { opacity: 0.52; transform: scale(1.05); }
        }
        .ominia-ring-pulse {
          animation: ominia-ring-pulse 2.4s ease-in-out infinite;
          transform-origin: 50px 50px;
        }
        .ominia-node-pulse {
          animation: ominia-node 2s ease-in-out infinite;
        }
        @keyframes ominia-node {
          0%, 100% { opacity: 0.72; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
